export enum LimaOperatorTask {
  undefined = -1,
  Plock = 10,
  Pack = 20,
  HämtaVagn = 21,
  BytVagn = 22,
  HjälpPlats = 23,
  Fortsätt = 24,
  HämtaVagnNärFärdig = 25,
  HjälpPlatsNärFärdig = 26,
  Inleverans = 30,
  Inventering = 40,
  PlockRX = 110,
  ExpeditionRX = 120,
  InleveransRX = 130,
  InventeringRX = 140,
  RegisterNormalTransportCart = 900,
  RegisterSingleTransportCart = 910,
  CheckRxSubsidy = 920
}

export enum LimaSortType {
  undefined = -1,
  singel = 1,
  normal = 2,
  aframe = 3,
  zone = 4,
}
